import Helpers from "../helpers";
export default class Tabs {
    constructor() {
        this.selectors = {
            element: '[data-tab]',
            wrapper: '[data-tab-wrapper]',
            trigger: '[data-tab-target]',
            target: '[data-tab-id]'
        };

        this.options = {
            fixedHeight: true,
        };

        this.states = {
            current: null,
            init: null
        };

        this.init();
    }

    init(){
        var self = this;

        $( self.selectors.element ).each( function() {
            var $element = $( this ),
            $wrapper = $element.find( self.selectors.wrapper ),
            $triggers = $element.find( self.selectors.trigger ),
            $targets = $element.find( self.selectors.target ),
            title = $( document.title ),
            baseURL = $element.attr( 'data-tab-base-url' ); 

            self.states.current = $targets.filter( '.active' ).attr( 'data-tab-id' );
            self.states.init = self.states.current;

            self.refreshHeights( $targets, $wrapper );

            $( window ).on( 'resize', Helpers.throttle( function() {
                self.refreshHeights( $targets, $wrapper );
            }, 200 ) );

            $triggers.on( 'click', function() {
                var $tabItem = $( this ),
                tabID = $tabItem.attr( 'data-tab-target' ),
                $target = $targets.filter( '[data-tab-id="' + tabID + '"]' );

                history.pushState( { target: tabID }, title, baseURL + '?room-type=' + tabID );

                if ( $target.length > 0 ) {
                    $triggers.removeClass( 'active' );
                    $targets.removeClass( 'active' );

                    $tabItem.addClass( 'active' );
                    $target.addClass( 'active' );

                    if ( self.options.fixedHeight === false ) {
                        $wrapper.css( 'height', $target.data( 'height' ) );
                    }

                    self.states.current = tabID;
                    $element.trigger( 'change' );
                }
            } );

            $( window ).on( 'popstate', function(e) {
                var tabID = self.states.init;

                if ( typeof e.originalEvent.state !== 'null' && e.originalEvent.state !== null ) {
                    if ( ( typeof e.originalEvent.state.target !== 'undefined' || typeof e.originalEvent.state.target !== 'null' ) ) {
                        tabID = e.originalEvent.state.target;
                    }
                }

                var $tabItem = $triggers.filter( '[data-tab-target="' + tabID + '"]' ),
                $target = $targets.filter( '[data-tab-id="' + tabID + '"]' );

                if ( $target.length > 0 ) {
                    $triggers.removeClass( 'active' );
                    $targets.removeClass( 'active' );

                    $tabItem.addClass( 'active' );
                    $target.addClass( 'active' );

                    if ( self.options.fixedHeight === false ) {
                        $wrapper.css( 'height', $target.data( 'height' ) );
                    }

                    self.states.current = tabID;
                    $element.trigger( 'change' );
                }
            } );
        } );
    }

    refreshHeights( $targets, $wrapper ) {
        var self = this,
        maxHeight = 0;

        $targets.each( function() {
            var $target = $( this ),
            height = parseInt(  $target.outerHeight() );

            $target.data( 'height', height );
            maxHeight = maxHeight < height ? height : maxHeight;
        } );

        if ( self.options.fixedHeight === true ) {
            $wrapper.css( 'height', maxHeight );
        }
    }
}